import React, { useEffect, useState } from 'react';
import { Field } from 'react-final-form';
import { FormApi } from 'final-form';

import { SpotAdapter } from './FormAdapters';
import genderIcons from '../../../svg/createOfferGenderIcons';

interface Props {
  strict?: Boolean;
  allowEither?: Boolean;
  values: CreateOffer;
  form: FormApi<CreateOffer>;
  onChanged?: Function;
}

interface State {
  type: string;
  gender: string | undefined;
}

class GenderPicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { type: 'all', gender: undefined };

    if (props.values.shared_spots) this.state = { type: 'shared', gender: 'shared' };

    if (!!props.values.female_spots || !!props.values.male_spots) {
      this.state = { type: 'gender', gender: 'shared' };
    }
  }

  onChanged(name: string, value: any) {
    let _gender: string = '';

    if (name === 'shared_spots' && parseInt(value) > 0) {
      _gender = 'shared';
    } else if (name === 'male_spots' && parseInt(value) > 0) {
      _gender = 'male';
    } else if (name === 'female_spots' && parseInt(value) > 0) {
      _gender = 'female';
    }

    if (this.props.onChanged && this.state.gender !== _gender) {
      this.props.onChanged(_gender);
    }

    this.state = {
      type: this.state.type,
      gender: _gender !== '' ? _gender : undefined,
    };

    return true;
  }

  changeFocus(type: string) {
    this.state = {
      type: type,
      gender: this.state.gender,
    };

    if (type === 'shared') {
      this.props.form.mutators.clearField('male_spots');
      this.props.form.mutators.clearField('female_spots');
    } else {
      this.props.form.mutators.clearField('shared_spots');
    }
  }

  strictCheck(type: string) {
    if (this.props.strict === true) {
      if (
        type === 'female_spots' &&
        (this.props.values.male_spots || this.props.values.shared_spots)
      )
        return false;

      if (
        type === 'male_spots' &&
        (this.props.values.female_spots || this.props.values.shared_spots)
      )
        return false;

      if (
        type === 'shared_spots' &&
        (this.props.values.male_spots || this.props.values.female_spots)
      )
        return false;
    }

    return true;
  }

  check(isBoth: boolean) {
    if (this.state.type === 'all') return true;
    else if ((this.state.type === 'shared' && isBoth) || (this.state.type === 'gender' && !isBoth))
      return true;

    return false;
  }

  render() {
    return (
      <>
        {this.props.allowEither === true ? (
          <div className="col2">
            {genderIcons('female', !this.check(true) || !this.strictCheck('shared_spots'))}
            &nbsp;&nbsp;
            {genderIcons('male', !this.check(true) || !this.strictCheck('shared_spots'))}
            <div
              style={{ fontSize: '10px', textAlign: 'center', opacity: this.check(true) ? 1 : 0.4 }}
            >
              Either
            </div>
            {this.strictCheck('shared_spots') ? (
              <Field
                name="shared_spots"
                render={(props) => (
                  <SpotAdapter
                    {...props}
                    disabled={!this.check(true) || !this.strictCheck('shared_spots')}
                    onChanged={(value) => this.onChanged('shared_spots', value)}
                    onFocus={() => this.changeFocus('shared')}
                  />
                )}
              />
            ) : (
              <input type="text" className="disabled" disabled={true} />
            )}
          </div>
        ) : null}

        <div className="col2">
          {genderIcons('female', !this.check(false) || !this.strictCheck('female_spots'))}
          <div
            style={{ fontSize: '10px', textAlign: 'center', opacity: this.check(false) ? 1 : 0.4 }}
            className={!this.strictCheck('female_spots') ? 'text-muted' : ''}
          >
            Female
          </div>

          {this.strictCheck('female_spots') ? (
            <Field
              name="female_spots"
              render={(props) => (
                <SpotAdapter
                  {...props}
                  onChanged={(value) => this.onChanged('female_spots', value)}
                  disabled={!this.check(false) || !this.strictCheck('female_spots')}
                  onFocus={() => this.changeFocus('gender')}
                />
              )}
            />
          ) : (
            <input type="text" className="disabled" disabled={true} />
          )}
        </div>

        <div className="col2">
          {genderIcons('male', !this.check(false) || !this.strictCheck('male_spots'))}

          <div
            style={{ fontSize: '10px', textAlign: 'center', opacity: this.check(false) ? 1 : 0.4 }}
            className={!this.strictCheck('male_spots') ? 'text-muted' : ''}
          >
            Male
          </div>

          {this.strictCheck('male_spots') ? (
            <Field
              name="male_spots"
              render={(props) => {
                return (
                  <SpotAdapter
                    {...props}
                    onChanged={(value) => this.onChanged('male_spots', value)}
                    disabled={!this.check(false) || !this.strictCheck('male_spots')}
                    onFocus={() => this.changeFocus('gender')}
                  />
                );
              }}
            />
          ) : (
            <input type="text" className="disabled" disabled={true} />
          )}
        </div>
      </>
    );
  }
}

export default GenderPicker;
